import React, { useState } from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';


function EditOption({ onOptionAdded, id, }) {

    const [show, setShow] = useState(false);
    const [name, setName] = useState('');

    const handleClose = () => {
        setShow(false);
        setName('');
    };

    const handleShow = async () => {
        try {
            const response = await axiosInstance.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/admin/option/${id}`
            );
            if (response.data.success) {
                setName(response.data.data.name);
                setShow(true);
            }
        } catch (error) {
            console.error('Error fetching option:', error.response.data.message);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const response = await axiosInstance.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/admin/option/edit/${id}`,
                { name }
            );

            if (response.data.success) {
                CustomToast.success(response.data.message);
                handleClose();
                if (onOptionAdded) onOptionAdded();
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error('Error updating option:', error.response.data.message);
        }
    };
    return (
        <>

            <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                    <Tooltip id="tooltip-top">
                        Edit
                    </Tooltip>
                }
            >
                <img src="/images/png/edit.png" onClick={handleShow} className="pointer" width={35} alt="action" />
            </OverlayTrigger>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Option</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">
                        <div className="col-12">
                            <Form.Group controlId="name">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter name"
                                    required
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div className='d-flex justify-content-center mt-4'>
                        <button className='btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-5' onClick={handleSubmit}>
                            Save
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditOption